export default {
  OPTION_STATUS_ALL: 'all',
};



// WEBPACK FOOTER //
// ./src/variables/gift-vouchers.js